import { styled } from "@mui/system";
import { Typography, Container, Stack, Box } from "@mui/material";
import Page from "../components/Page";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: "flex",
  minHeight: "100vh",
  alignItems: "center",
  background:
    "radial-gradient(circle at 20% 20%, #0b5b8e 0%, #064a73 35%, #033657 100%)",
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
}));

const ContentCard = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: 980,
  borderRadius: 24,
  padding: theme.spacing(5, 4),
  background:
    "linear-gradient(135deg, rgba(255,255,255,0.14), rgba(255,255,255,0.07))",
  backdropFilter: "blur(6px)",
  border: "1px solid rgba(255,255,255,0.20)",
  boxShadow: "0 24px 60px rgba(0, 0, 0, 0.25)",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(4, 2.5),
    borderRadius: 18,
  },
}));

// ----------------------------------------------------------------------

export default function Maintenance() {
  const today = new Date();
  const date = today.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
  });

  return (
    <RootStyle title="Manutenção | Optools">
      <Container>
        <ContentCard>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2.5}
            textAlign="center"
          >
            <Typography
              variant="overline"
              sx={{
                letterSpacing: 2,
                color: "rgba(255,255,255,0.85)",
                fontSize: 12,
              }}
            >
              AVISO IMPORTANTE
            </Typography>

            <Typography
              variant="h2"
              color="white"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "2rem", md: "3rem" },
                lineHeight: 1.1,
              }}
            >
              Estamos em manutenção
            </Typography>

            <Typography
              variant="h5"
              color="white"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1.15rem", md: "1.5rem" },
              }}
            >
              Previsão para voltar hoje ({date}) às 20:00
            </Typography>

            <Typography
              color="rgba(255,255,255,0.90)"
              sx={{ maxWidth: 640, fontSize: { xs: "0.95rem", md: "1.05rem" } }}
            >
              Estamos aplicando melhorias importantes para deixar o sistema mais
              estável e rápido. Obrigado pela compreensão.
            </Typography>

            <Box
              sx={{
                mt: { xs: 1, md: 2 },
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                src="/static/illustrations/undraw_maintenance.svg"
                alt="Manutenção do sistema"
                sx={{
                  width: { xs: 220, sm: 280, md: 340 },
                  maxWidth: "100%",
                  filter: "drop-shadow(0 14px 30px rgba(0, 0, 0, 0.2))",
                }}
              />
            </Box>
          </Stack>
        </ContentCard>
      </Container>
    </RootStyle>
  );
}
